var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "add_real_task_wrap" },
    [
      _c("h2", { staticClass: "add_real_task_wrap_h2" }, [
        _vm._v(_vm._s(_vm.drawerTitle))
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "realTaskForm",
          style: "height:" + (_vm.windowHeight - 80) + "px",
          attrs: { model: _vm.realTaskForm, rules: _vm.realTaskFormRules }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "48%" },
                  attrs: { label: "知识点", prop: "knowledgePoints" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { multiple: "", placeholder: "请选择知识点" },
                      model: {
                        value: _vm.realTaskForm.knowledgePoints,
                        callback: function($$v) {
                          _vm.$set(_vm.realTaskForm, "knowledgePoints", $$v)
                        },
                        expression: "realTaskForm.knowledgePoints"
                      }
                    },
                    [
                      _vm.knowledgePointsList.length > 0
                        ? _c(
                            "div",
                            _vm._l(_vm.knowledgePointsList, function(item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id }
                              })
                            }),
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "pelabel",
                  staticStyle: { width: "48%" },
                  attrs: { label: "任务类型", prop: "taskType" }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "pospan",
                      staticStyle: { color: "firebrick" }
                    },
                    [_vm._v("（任务推送后，任务类型则不可修改）")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择任务类型",
                        disabled: _vm.isDisabled
                      },
                      model: {
                        value: _vm.realTaskForm.taskType,
                        callback: function($$v) {
                          _vm.$set(_vm.realTaskForm, "taskType", $$v)
                        },
                        expression: "realTaskForm.taskType"
                      }
                    },
                    [
                      _vm.taskTypeList.length > 0
                        ? _c(
                            "div",
                            _vm._l(_vm.taskTypeList, function(item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id }
                              })
                            }),
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "48%" },
                  attrs: { label: "任务名称", prop: "taskTitle" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入任务名称", maxlength: "50" },
                    model: {
                      value: _vm.realTaskForm.taskTitle,
                      callback: function($$v) {
                        _vm.$set(_vm.realTaskForm, "taskTitle", $$v)
                      },
                      expression: "realTaskForm.taskTitle"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "48%" },
                  attrs: { label: "所属公司", prop: "company" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择所属公司",
                        filterable: "",
                        clearable: ""
                      },
                      model: {
                        value: _vm.realTaskForm.company,
                        callback: function($$v) {
                          _vm.$set(_vm.realTaskForm, "company", $$v)
                        },
                        expression: "realTaskForm.company"
                      }
                    },
                    [
                      _vm.companyList.length > 0
                        ? _c(
                            "div",
                            _vm._l(_vm.companyList, function(item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id }
                              })
                            }),
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "任务内容", prop: "taskContent" } },
            [
              _c("v-editor", {
                key: _vm.onlyKey,
                staticClass: "taskContent",
                model: {
                  value: _vm.realTaskForm.taskContent,
                  callback: function($$v) {
                    _vm.$set(_vm.realTaskForm, "taskContent", $$v)
                  },
                  expression: "realTaskForm.taskContent"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-addFile", {
            attrs: { isUploading: _vm.isUploading },
            on: { changeUploadStatus: _vm.changeUploadStatus },
            model: {
              value: _vm.attachmentList,
              callback: function($$v) {
                _vm.attachmentList = $$v
              },
              expression: "attachmentList"
            }
          }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "btn" },
            [
              _c("el-button", { on: { click: _vm.submitCancel } }, [
                _vm._v("取消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.submitForm("realTaskForm")
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-334cca3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-334cca3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/course/components/addRealTask.vue
// module id = null
// module chunks = 